module.exports = __webpack_public_path__ + "img/example_with_psoriasis.bfcc3cfd.png";